import { render, staticRenderFns } from "./ProductoForm.vue?vue&type=template&id=639d0eb6&"
import script from "./ProductoForm.vue?vue&type=script&lang=js&"
export * from "./ProductoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports